/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import QueryProvider from "./context/QueryProvider";
import "./index.css";
import { updateAxiosConfig } from "./axios.init";

const SimplyBookWidget = (targetElement, { apiKey, company, baseUrl, theme }) => {
  const root = ReactDOM.createRoot(targetElement);

  updateAxiosConfig({
    baseURL: baseUrl || "https://user-api-v2.simplybook.webnode.page",
    companyLogin: company,
    apiKey: apiKey,
  });

  root.render(
    <React.StrictMode>
      <QueryProvider>
        <App companyKey={apiKey} companyName={company} theme={theme} />
      </QueryProvider>
    </React.StrictMode>
  );

  return () => {
    root.unmount();
  };
};

window.SimplyBookWidget = SimplyBookWidget;
